import { environment } from 'src/environment';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SettingsService, BaseService, StorageService } from 'src/app/core/services';
import { CategoriesService } from 'src/app/core/services/categories.service';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { FooterService } from 'src/app/core/services/footer.service';
import { LanguageService } from 'src/app/core/services/language.service';
import { ContentService } from 'src/app/core/services/content.service';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';
import { ApplicationService } from 'src/app/core/services/application.service';

@Component({
  selector: 'app-change-language',
  templateUrl: './change-language.component.html',
  styleUrls: ['./change-language.component.scss', '../modal-screens.scss']
})
export class ChangeLanguageComponent implements OnInit {

  selectedLocale;
  locales;
  selectedLang;
  selectedLocaleKey;
  locale: any;
  private changedLocale = false;

  skinName = environment.skinName;
  constructor(public settingsService: SettingsService, public languageService: LanguageService,
    public configService: ConfigurationService, private router: Router,
    private route: ActivatedRoute, public baseService: BaseService, private storageService: StorageService,
    private categoryService: CategoriesService, private footerService: FooterService, private contentService: ContentService,
    private analyticsService: InhouseAnalyticsService, private applicationService:ApplicationService) {
      this.locales = this.languageService.appLanguage;
      this.applicationService.translateSelectedLocale().then((selectedLocale) =>  {
        this.selectedLocale = selectedLocale;
      });
      this.selectedLocaleKey = this.configService.locales[this.configService.localeIndex].lang_code;
    }

  ngOnInit(): void {
    this.locales = this.applicationService.translateLanguage(this.locales);
  }

  setLocale(i, value) {
    this.selectedLocale = value.translatedLanguage;
    this.selectedLocaleKey = value.lang_code;
    this.configService.localeIndex = i;
    this.configService.locale = this.selectedLocaleKey;
  }

  changeLocale() {
    this.selectedLocaleKey = this.configService.locales[this.configService.localeIndex].lang_code;
    this.configService.activeLocale = this.configService.locales[this.configService.localeIndex].lang_name;
    let localeAvailable;
    this.locales.find((item, i) => {
      if (item.lang_code === this.selectedLocaleKey) {
        localeAvailable = i;
        return i;
      }
    });
    this.storageService.setLocalStore('locale', this.selectedLocaleKey);
    this.storageService.setLocalStore('localeName', this.configService.activeLocale);
    this.configService.setlocaleCookie(this.selectedLocaleKey);
    this.locale = this.selectedLocaleKey;
    this.changedLocale = true;
    const eventObj = {
      event_type: 'Event',
      event_name: 'Change App Language',
      event_status: 'Success',
      event_description: this.selectedLocaleKey
    };
    this.analyticsService.trackUserActions(eventObj);

    window.location.reload();
  }


}
